import jjv from 'jjv'

export function createValidator() {
    const validator = jjv()

    validator.addCheck('equals', (v, p) => {
        if (typeof v == 'object') {
            for (var i = 1 ; i < p.length ; i++) {
                if (v[p[i - 1]] != v[p[i]]) return false
            }
        }
        return true
    })

    return validator
}

export class Credential {
}

Credential.schema = {
    type: 'object',
    properties: {
        login: {type: 'string'},
        password: {type: 'string'}
    },
    required: ['login', 'password']
}

export class ActiveUserCmd {
}

ActiveUserCmd.schema = {
    type: 'object',
    properties: {
        password: {type: 'string'},
        confirmPassword: {type: 'string'},
    },
    equals: ['password', 'confirmPassword'],
    required: ['password', 'confirmPassword']
}

export class ResetPasswordDemand {
}

ResetPasswordDemand.schema = {
    type: 'object',
    properties: {
        email: {type: 'string'}
    },
    required: ['email']
}

export class ResetPasswordCmd {
}

ResetPasswordCmd.schema = {
    type: 'object',
    properties: {
        password: {type: 'string'},
        confirmPassword: {type: 'string'},
    },
    equals: ['password', 'confirmPassword'],
    required: ['password', 'confirmPassword']
}

export class UpdateUserCmd {
}

UpdateUserCmd.schema = {
    type: 'object',
    properties: {
        firstName: {type: 'string'},
        lastName: {type: 'string'},
        job: {type: ['string', 'null']},
        phone: {type: ['string', 'null']}
    },
    required: ['firstName', 'lastName']
}

export class ResetLoginDemand {
}

ResetLoginDemand.schema = {
    type: 'object',
    properties: {
        newLogin: {
            type: 'string',
            format: 'email'
        }
    },
    required: ['newLogin']
}

export class UserConfigs {
}

UserConfigs.schema = {
    type: 'object',
    properties: {
        ticketOpenedNotifications: {type: 'boolean'},
        daybookNotifications: {type: 'boolean'},
        simplifiedRequestOpenedNotifications: {type: 'boolean'}
    }
}



// WEBPACK FOOTER //
// ./lib/user/models.js